<script setup lang="ts">
  import { IFormItem, IRtl } from '../utils/interfaces';
  import { useClearCss } from '../hooks/useClearCss';

  interface ContactFormOtherOptionsProps {
    formItem: IFormItem;
    rtlItem: IRtl;
  };

  defineProps<ContactFormOtherOptionsProps>();
  const { clearCss } = useClearCss();
</script>

<template>
  <div class="other-options-container" data-pw-form="contact-form-other-options">
    <div class="form-details">
      <div class="form-details-two-columns">
        <FormKit 
          type="text"
          name="firstName"
          :input-class="{ 'text-rtl': rtlItem.useRtl }"
          :dir="rtlItem.currentDirection"
          :label="formItem.firstNameLabel"
          validation="required"
          :validation-messages="{ required: formItem.firstNameErrorMessage }"
          input-class="first-name-input"
          data-pw-form="contact-form-first-name"
        />
        <FormKit 
          type="text"
          name="lastName"
          :input-class="{ 'text-rtl': rtlItem.useRtl }"
          :dir="rtlItem.currentDirection"
          :label="formItem.lastNameLabel"
          validation="required"
          :validation-messages="{ required: formItem.lastNameErrorMessage }"
          input-class="last-name-input"
          data-pw-form="contact-form-last-name"
        />
      </div>
      <FormKit
        type="email"
        name="email"
        :label="formItem.emailLabel"
        validation="required|email"
        :validation-messages="{required: formItem.emailAddressErrorMessage, email: formItem.emailAddressErrorMessage}"
        input-class="email-input"
        data-pw-form="contact-form-email"
      />
    </div>
    <div class="form-message">
      <FormKit
        type="textarea"
        name="message"
        :input-class="{ 'text-rtl': rtlItem.useRtl }"
        :dir="rtlItem.currentDirection"
        :label="formItem.messageLabel"
        validation="required"
        :validation-messages="{ required: formItem.messageErrorMessage }"
        data-pw-form="contact-form-message"
      />
    </div>
    <div 
      v-html="clearCss(formItem.recaptchaInformationalMessage.html)"
      class="form-recaptcha-message"
      data-pw-form="contact-form-recaptcha-message"
    />
    <div class="form-submit">
      <FormKit 
        type="submit"
        :label="formItem.formSubmitLabel"
        data-pw-form="contact-form-submit"
      />
    </div>
  </div>
</template>
